import React from "react";

type Props = {
  programName: string;
  intakes: string[];
};

export default function ProgramIntakes({ programName, intakes }: Props) {
  return (
    <div role="list" aria-label={`Intakes for ${programName}`}>
      {intakes.map((intake) => (
        <span role="listitem" key={intake} className="program-intakes">
          {intake}
        </span>
      ))}
    </div>
  );
}
